export function validUrl(url: string, validPrefixes: string[]): boolean {
  const prefixesPattern = validPrefixes.join("|");

  const regex = new RegExp(`/(${prefixesPattern})/\\d+`);
  return regex.test(url);
}

export function isXylemeSyndicateCourse(result: any): boolean {
  //should return true for URLs that start with https:// and include cisco.bravais.com
  // or if authoring_platform is 'Create' or content_provider is 'Syndicate'

  const urlPattern =
    /^https:\/\/(?:.*[-.])?cisco(?:\.beta)?\.bravais\.com(?:\/.*)?$/;
  const isMatchingUrl = urlPattern.test(result.url);
  const isAuthoringPlatformCreate = result.authoring_platform === "Create";
  const isContentProviderSyndicate = result.content_provider === "Syndicate";

  return (
    isMatchingUrl || isAuthoringPlatformCreate || isContentProviderSyndicate
  );
}

const MINDTICKLE_DOMAIN = "cisco.mindtickle.com";

export function isMindtickleCourse(courseOrResult: any): boolean {
  const url = getCleanXylemeCourseUrl(courseOrResult);
  if (!url) {
    return false;
  }

  try {
    return new URL(url).hostname.toLowerCase() === MINDTICKLE_DOMAIN;
  } catch {
    return false;
  }
}

/**
 * Gets the clean URL for XylemeSyndicate courses without any added parameters
 * This avoids return_url and return_text parameters being added by linkBackFormat()
 * @param courseOrResult - The course or result object that may contain URL data
 * @returns The clean URL string
 */
export function getCleanXylemeCourseUrl(courseOrResult: any): string {
  return courseOrResult?.catalog_data?.url || courseOrResult?.url || "";
}
